export default "__VITE_ASSET___xslSqtx__"